// Role of this file:
// Listen for an action
// produce a side effect which is communicate with the server via http,
// bring data back and dispatch a new action (success or fail)
// Actions is an observable that listens to the types of actions
// being dispatched and we can respond accordingly

// Angular Stuff
import { Injectable } from "@angular/core";

// rxjs
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

// Store Stuff
import { CoursesService } from "@carnegie-learning/data-access-angular-passport";
import * as fromCoursesActions from "../actions/courses.action";

// Services

@Injectable()
export class CoursesEffects {
    constructor(
        private actions$: Actions,
        private coursesService: CoursesService
    ) {}

    loadCoursesForLanguage$ = createEffect(() =>
        this.actions$
            .pipe(ofType(fromCoursesActions.loadClassesForSubject))
            // produce a side effect
            .pipe(
                map((action) => action.subjectId),
                switchMap((subjectId) => {
                    return this.coursesService
                        .getClassesForSubject(subjectId)
                        .pipe(
                            map((courses) => courses),
                            map((response) => {
                                return fromCoursesActions.loadClassesForSubjectSuccess(
                                    { payload: response }
                                );
                            }),
                            // need to wrap the error in 'of' so it becomes an observable action
                            catchError((error) =>
                                of(
                                    fromCoursesActions.loadClassesForSubjectFail(
                                        { payload: error }
                                    )
                                )
                            )
                        );
                })
            )
    );
}
